if ("IntersectionObserver" in window) {
	var options = {
		root: null,
		rootMargin: "0px 0px 400px",
		threshold: 0,
	};

	var onIntersectionChange = function (changes, observer) {
		changes.forEach((change) => {
			if (change.intersectionRatio > 0) {
				loadImageVideo(change.target);
			}
		});
	};

	var observer = new IntersectionObserver(onIntersectionChange, options);

	function setup() {
		var elements = document.querySelectorAll(".video_wrapper.lazy");
		elements.forEach((element) => observer.observe(element));
	}

	setup();

	setTimeout(setup, 1000);
	setTimeout(setup, 3000);
} else {
	var lazyElements = document.querySelectorAll(".video_wrapper.lazy");
	for (var i = 0; i < lazyElements.length; i++) {
		loadImageVideo(lazyElements[i]);
	}
}

function loadImageVideo(target) {
	if (!target.classList.contains("lazy")) {
		return;
	}

	var embedCode = target.getAttribute("data-video-embed");
	if (embedCode) {
		target.innerHTML = embedCode;
	}

	target.classList.remove("lazy");
	target.classList.add("show");
}